import unescapedText from 'I18n/utils/unescapedText';
import { useMemo } from 'react';
import { useAppliedFilters } from './useAppliedFilters';
export function useFilterTags() {
  const appliedFilters = useAppliedFilters();
  const filterTags = useMemo(() => {
    const tags = [];
    for (const appliedFilter of appliedFilters) {
      // Special handling for language filters
      if (appliedFilter.isLanguage) {
        tags.push(...appliedFilter.values.map(value => {
          var _ref, _appliedFilter$label;
          return {
            field: appliedFilter.field,
            text: unescapedText(`SharedI18nStrings.languageNames.${value}`),
            tooltip: (_ref = (_appliedFilter$label = appliedFilter.label) !== null && _appliedFilter$label !== void 0 ? _appliedFilter$label : appliedFilter.placeholder) !== null && _ref !== void 0 ? _ref : '',
            value
          };
        }));
        continue;
      }

      // Flatten the options if necessary
      const options = appliedFilter.options.length > 0 ? appliedFilter.options : appliedFilter.optionGroups.flatMap(group => group.options);
      for (const option of options) {
        if (appliedFilter.values.includes(option.value)) {
          var _ref2, _appliedFilter$label2;
          tags.push({
            field: appliedFilter.field,
            text: option.text,
            tooltip: (_ref2 = (_appliedFilter$label2 = appliedFilter.label) !== null && _appliedFilter$label2 !== void 0 ? _appliedFilter$label2 : appliedFilter.placeholder) !== null && _ref2 !== void 0 ? _ref2 : '',
            value: option.value
          });
        }
      }
    }
    return tags;
  }, [appliedFilters]);
  return filterTags;
}